import(/* webpackMode: "eager" */ "/usr/src/src/app/global-error.jsx");
